import axios from 'axios';
import requestApi, { get } from '../../../apirest';
import { apiURL } from '../../../apirest/getAPIURL';

export async function listCoupons() {
  const response = await requestApi('/coupons', null, 'get');
  return response.data.doc;
}

export async function getCouponById(id) {
  const response = await get('/coupons/findById', { id });
  return response.data.doc;
}

export async function createCoupon(coupon) {
  const response = await requestApi('/coupons', { coupon }, 'post');
  return response.data;
}

export async function updateCoupon(coupon) {
  const response = await requestApi('/coupons', { coupon }, 'patch');
  return response.data;
}

export async function getCouponStats(start, end) {
  const response = await get('/coupons/stats', { start, end });
  return response.data;
}

export async function deleteCoupon(id) {
  const response = await axios.delete(`${apiURL}/coupons/${id}`, {
    headers: { 'Cache-Control': 'no-cache', 'Content-Type': 'application/json' },
  });
  return response.data;
}
